<div
  class="flex flex-col gap-4"
  [ngClass]="{
    'px-8 md:px-32 lg:px-56 py-16 md:py-24': carouselData.size === 'small',
  }"
  ssWwwSwipe
  [index]="currentIndex"
  [length]="carouselData.images.length"
  (nextIndex)="setActiveIndex($event)"
  [@slideRound]="animationState"
>
  @if (carouselData.title) {
    <h2
      class="text-center"
      [ngClass]="{ 'px-8': carouselData.size === 'large' }"
      [ssDirectus]="{
        collection: 'carousels',
        item: carouselData.id,
        fields: ['title'],
      }"
    >
      {{ carouselData.title }}
    </h2>
  }
  <!-- Image Section -->

  <div
    class="relative overflow-hidden"
    [ssDirectus]="{
      collection: 'carousels',
      item: carouselData.id,
      fields: ['images', 'watermarkImage', 'size'],
    }"
  >
    <div>
      @for (
        image of carouselData.images;
        track imgTrackBy(i, image);
        let i = $index
      ) {
        @if (currentIndex === i) {
          <div>
            <ss-www-image-with-loader
              [@.disabled]="true"
              class="relative w-full"
              [ngClass]="{
                'rounded-xl md:rounded-2xl aspect-[4/3] md:aspect-video':
                  carouselData.size === 'small',
                'w-full h-full aspect-[5/3] md:aspect-[7/3]':
                  carouselData.size === 'large',
              }"
              [fileDetail]="image.directus_files_id"
              [desktopImageSize]="
                carouselData.size === 'large' ? 'full' : '2/3rds'
              "
              [isGallery]="true"
            >
              @if (carouselData.watermarkImage?.id) {
                <img
                  class="bottom-5 right-5 absolute z-10"
                  [ngSrc]="carouselData.watermarkImage!.id"
                  width="70"
                  height="40"
                  alt="Watermark"
                />
              }
            </ss-www-image-with-loader>
          </div>
        }
      }
    </div>
    @if (carouselData.size === 'large' && (isSmallScreen$ | async) === false) {
      <div
        class="flex justify-center items-center md:items-end absolute -bottom-16 md:bottom-0 md:pb-4 left-0 right-0 z-10 h-10 md:h-32 bg-gradient-to-t from-ss-www-background to-transparent"
      >
        <ss-www-carousel-controls
          [currentIndex]="currentIndex"
          [items]="carouselData.images"
          (nextIndex)="setActiveIndex($event)"
        ></ss-www-carousel-controls>
      </div>
    }
  </div>

  @if (carouselData.size === 'small' || (isSmallScreen$ | async) === true) {
    <ss-www-carousel-controls
      [currentIndex]="currentIndex"
      [items]="carouselData.images"
      (nextIndex)="setActiveIndex($event)"
    ></ss-www-carousel-controls>
  }
</div>
